import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Form } from 'formik';

export const ButtonsContainerStyled = styled(Box)(({ theme }) => ({
  height: '64px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  borderBottomLeftRadius: '5px',
  borderBottomRightRadius: '5px',
  backgroundColor: theme.palette.colors.primaryBackground,
  margin: '0 auto 8px',
  width: '440px',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    position: 'static',
    margin: 0,
  },
}));

export const FormStyled = styled(Form, {
  shouldForwardProp: (prop) => prop !== 'activeStep',
})(({ theme, activeStep }) => {
  const getChangingProperties = () => {
    if (activeStep === 0) {
      return {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'hidden',
        [theme.breakpoints.down('lg')]: {
          display: 'block',
          overflowY: 'auto',
          paddingRight: '6px',
        },
      };
    }

    if (activeStep === 1) {
      return {
        overflowY: 'auto',
        paddingRight: '6px',
        marginBottom: '64px',
        [theme.breakpoints.down('lg')]: {
          marginBottom: 0,
        },
      };
    }

    return {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'hidden',
      [theme.breakpoints.down('lg')]: {
        overflowY: 'auto',
        paddingRight: '6px',
      },
    };
  };

  return {
    ...getChangingProperties(),

    '@-moz-document url-prefix()': {
      scrollbarColor: `${theme.palette.colors.scrollOnPrimaryBackground} transparent`,
      scrollbarWidth: 'thin',
    },
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.colors.scrollOnPrimaryBackground,
      borderRadius: '5px',
    },
  };
});
